import { createApi } from '@reduxjs/toolkit/query/react';
import BASE_QUERY from '../baseQuery';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';

export const complianceStepsApi = createApi({
	reducerPath: 'complianceStepsApi',
	tagTypes: ['COMPLIANCE_STEPS', 'BROKER_COMPLIANCE_QUESTIONS'],
	baseQuery: fetchBaseQuery({
		...BASE_QUERY,
		baseUrl: process.env.REACT_APP_BROKER_COMPLIANCE_STEPS,
	}),
	keepUnusedDataFor: 900, // Cache will only clear after 900 seconds (15 minutes)
	endpoints: (builder) => ({
		listBrokerComplianceSteps: builder.query({
			// brokerGroupArray isn't sent to the backend — the server derives it from the
			// authenticated user's own broker groups — but it's kept as a param here so
			// providesTags below can key the cache off it.
			query: ({ brokerGroupArray, pipelineId, includeInactive }) => ({
				url: '/list',
				method: 'POST',
				body: { pipelineId, includeInactive },
			}),
			providesTags: (result, error, { brokerGroupArray }) => [
				{ type: 'BROKER_COMPLIANCE_QUESTIONS', id: brokerGroupArray },
			],
			transformErrorResponse: (response) => {
				console.error('Error fetching broker compliance questions:', response);
				return response;
			},
			transformResponse: (response) => {
				console.log('Broker compliance questions response:', response);
				return response.data;
			},
		}),

		createBrokerComplianceStep: builder.mutation({
			// brokerGroupArray isn't sent to the backend — the server derives it from the
			// authenticated user's own broker groups — but it's kept as a param here so
			// invalidatesTags below can key the cache off it.
			query: ({ brokerGroupArray, pipelineId, name, description, stage, isActive }) => ({
				url: '/create',
				method: 'POST',
				body: { pipelineId, name, description, stage, isActive },
			}),
			invalidatesTags: (result, error, { brokerGroupArray }) => [
				{ type: 'BROKER_COMPLIANCE_QUESTIONS', id: brokerGroupArray },
			],
			transformErrorResponse: (response) => {
				console.error('Error creating broker compliance step:', response);
				return response;
			},
			transformResponse: (response) => {
				console.log('Create broker compliance step response:', response);
				return response;
			},
		}),

		updateBrokerComplianceStep: builder.mutation({
			// brokerGroupArray isn't sent to the backend — access is authorized off the
			// step's own stored broker groups — but it's kept as a param here so
			// invalidatesTags below can key the cache off it.
			query: ({ brokerGroupArray, stepId, updates }) => ({
				url: '/update',
				method: 'POST',
				body: { stepId, updates },
			}),
			invalidatesTags: (result, error, { brokerGroupArray }) => [
				{ type: 'BROKER_COMPLIANCE_QUESTIONS', id: brokerGroupArray },
			],
			transformErrorResponse: (response) => {
				console.error('Error updating broker compliance set:', response);
				return response;
			},
			transformResponse: (response) => {
				console.log('Update broker compliance set response:', response);
				return response;
			},
		}),
		deleteBrokerComplianceStep: builder.mutation({
			// brokerGroupArray isn't sent to the backend — access is authorized off the
			// step's own stored broker groups — but it's kept as a param here so
			// invalidatesTags below can key the cache off it.
			query: ({ stepId, brokerGroupArray }) => ({
				url: '/delete',
				method: 'POST',
				body: { stepId },
			}),
			invalidatesTags: (result, error, { brokerGroupArray }) => [
				{ type: 'BROKER_COMPLIANCE_QUESTIONS', id: brokerGroupArray },
			],
			transformErrorResponse: (response) => {
				console.error('Error deleting broker compliance step:', response);
				return response;
			},
			transformResponse: (response) => {
				console.log('Delete broker compliance step response:', response);
				return response;
			},
		}),
		initializeBrokerComplianceSteps: builder.mutation({
			// brokerGroupArray isn't sent to the backend — the server derives it from the
			// authenticated user's own broker groups — but it's kept as a param here so
			// invalidatesTags below can key the cache off it.
			query: ({ brokerGroupArray }) => ({
				url: '/initialize',
				method: 'POST',
				body: {},
			}),
			invalidatesTags: (result, error, { brokerGroupArray }) => [
				{ type: 'BROKER_COMPLIANCE_QUESTIONS', id: brokerGroupArray },
			],
			transformErrorResponse: (response) => {
				console.error('Error initializing broker compliance steps:', response);
				return response;
			},
			transformResponse: (response) => {
				console.log('Initialize broker compliance steps response:', response);
				return response;
			},
		}),
	}),
});

export const {
	useListBrokerComplianceStepsQuery,
	useCreateBrokerComplianceStepMutation,
	useUpdateBrokerComplianceStepMutation,
	useDeleteBrokerComplianceStepMutation,
	useInitializeBrokerComplianceStepsMutation,
} = complianceStepsApi;
